/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOverviewPage: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-overview", jiraSpaEntry: "async-jira-eoc-overview" */ '@jira/eoc__overview/src/ui/overview-page/index.tsx'
	).then((m) => m.OverviewPage),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOverviewAllTeamsPage: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-all-teams", jiraSpaEntry: "async-jira-eoc-all-teams" */ '@jira/eoc__overview/src/ui/all-teams-page/index.tsx'
	).then((m) => m.AllTeamsPage),
);

export const EocOverviewComponent = (): React.JSX.Element => (
	<LazyPage Page={LazyOverviewPage} pageId="async-jira-eoc-overview" shouldShowSpinner={false} />
);

export const EocOverviewAllTeamsComponent = (): React.JSX.Element => (
	<LazyPage
		Page={LazyOverviewAllTeamsPage}
		pageId="async-jira-eoc-overview-all-teams"
		shouldShowSpinner={false}
	/>
);
